
import { eoRendererMixin, metaDataMixin } from '~/mixins'

export default {
  mixins: [
    eoRendererMixin,
    metaDataMixin,
  ],
  async asyncData ({ $api, params: { slug }, store, route, error }) {
    const {
      data: {
        items: [
          person = {},
        ] = [],
      } = {},
    } = await $api.persons.getOneBySlug(slug, {
      domain: 'generieke-content-eo',
    })

    if (!person.id) {
      error({
        context: `Couldn't find person: ${slug}.`,
        message: '(404) Auteur niet gevonden',
        severity: 'warning',
        statusCode: 404,
      })
      return false
    }

    // Set breadcrumbs
    await store.dispatch('breadcrumbs/set', {
      path: route.path,
      width: 12,
      eoRoot: false,
      items: [
        {
          to: '/bloggers',
          label: 'Bloggers',
        },
        {
          label: person.name,
        },
      ],
    })

    return person
  },
  data () {
    return {
      isMounted: false,
      biographyHeight: 200, // default before calculation
      biographyMaxHeight: 185, // fixed
      isBiographyMinimized: true,
      articles: [],
      articlesToFetch: null,
      biography: null,
      id: null,
      name: null,
    }
  },
  async fetch () {
    const {
      data: {
        items: articles = [],
        meta: {
          total = 0,
        } = {},
      } = {},
    } = await this.$api.articles.getAll({
      person: this.id,
      personRole: 'author',
      offset: this.articles.length,
      limit: 6,
    })

    this.articles.push(...articles)
    this.articlesToFetch = total - this.articles.length
  },
  computed: {
    firstName () {
      return this.name.split(' ')[0]
    },
  },
  mounted () {
    this.isMounted = true
    if (!this.biography) this.biographyHeight = 0
  },
  methods: {
    onBiographyResize (measurements) {
      this.biographyHeight = measurements.height
    },
  },
}
